import { Injectable } from "@angular/core";
import { ActivatedRoute, CanActivate, Router } from "@angular/router";
import { first } from "rxjs/operators";
import { Store } from "@ngrx/store";

import { getOrganization } from "@app/user/user.actions";
import { UserAuthService } from "../services/user-auth.service";
import { ExternalDocumentDto } from "../services/external-source-document-open.service";
import { CheckDocumentsService } from "../services/check-documents.service";

@Injectable()
export class ExternalSourceDocumentOpenGuard implements CanActivate {

	constructor(
		private router: Router,
		private readonly authService: UserAuthService,
		private activatedRoute: ActivatedRoute,
		private checkDocumentsService: CheckDocumentsService,
		private store: Store,
	) { }

	public async canActivate(): Promise<boolean> {
		const token = await this.authService.token$.pipe(first()).toPromise();
		if (!token) {
			setTimeout(() => {
				const data = this.activatedRoute.snapshot.queryParams as { [key: string]: any };

				this.router.navigate(["user/login"], { queryParams: {
					documentNumber: data.documentNumber,
					messageType: data.messageType
				} });
			}, 500);
			return true;
		} else {
			setTimeout(() => {
				this.store.dispatch(getOrganization());
				const data = this.activatedRoute.snapshot.queryParams as ExternalDocumentDto;

				this.checkDocumentsService.openExternalDocument(data);
			}, 500)
			return true;
		}
	}
}
